'use client';

import React from 'react';
import { EmbedBlockData } from '../../editorjs.types';
import styles from './EmbedPlugin.module.scss';
import { embedServices } from './embedServices';

interface EmbedPluginProps {
  block: {
    data: EmbedBlockData;
  };
}

const EmbedPlugin: React.FC<EmbedPluginProps> = ({ block }) => {
  const { data } = block;

  const aspectRatio = data.height && data.width ? (data.height / data.width) * 100 : 56.25;

  const embedUrl = getEmbedUrl(data);

  if (!embedUrl) {
    return <div>Невозможно отобразить embed ({data.service})</div>;
  }

  return (
    <div className={styles.embedContainer}>
      <div className={styles.embedWrapper} style={{ paddingBottom: `${aspectRatio}%` }}>
        <iframe
          src={embedUrl}
          width="100%"
          height="100%"
          frameBorder="0"
          allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock"
          allowFullScreen
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', borderRadius: 14}}
        />
      </div>
      {data.caption && <div className={styles.embedCaption}>{data.caption}</div>}
    </div>
  );
};

function getEmbedUrl(data: EmbedBlockData): string | null {
  const service = data.service;
  const config = embedServices[service];

  if (!config) return data.embed || null;

  // Пример: https://www.youtube.com/embed/<%= remote_id %>
  let remoteId = '';

  if (config.id) {
    // Парсим ID из ссылки
    const match = serviceRegex[service]?.exec(data.source || data.embed || '');
    if (!match) return null;
    const ids = match.slice(1); // Убираем весь match, берем группы
    remoteId = config.id(ids);
  } else {
    // Простая замена, если id не нужен
    const match = /\/([^/?&]+)$/.exec(data.source || data.embed || '');
    remoteId = match?.[1] || '';
  }

  return config.embedUrl.replace('<%= remote_id %>', remoteId);
}

// Регулярки для ID (можно вынести в отдельный файл)
const serviceRegex: Record<string, RegExp> = {
  youtube: /(?:youtu\.be\/|v=|embed\/)([^#&?]+)/,
  vimeo: /vimeo\.com\/(\d+)/,
  vk: /vk\.com\/video([-]?\d+)_(\d+)/,
  'vk-video': /vkvideo\.ru\/video([-]?\d+)_(\d+)/,
  'gist.github': /gist\.github\.com\/([^/]+)\/([^/]+)/,
};

export default EmbedPlugin;
